import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const Hero = () => {
  console.log("[Hero] Rendering start");
  const [isRendered, setIsRendered] = useState(false);
  
  useEffect(() => {
    console.log("[Hero] Component mounted");
    
    // Mark as rendered for tracking
    setIsRendered(true);
    
    // Check if all required dependencies are available
    if (!Button) console.error("[Hero] Button component is not defined");
    if (!Link) console.error("[Hero] Link component is not defined");
    
    try {
      // Try to access DOM to verify rendering
      const heroElement = document.querySelector('.bg-gradient-to-b');
      console.log("[Hero] Hero element found in DOM:", !!heroElement);
      
      if (heroElement) {
        console.log("[Hero] Hero element classes:", heroElement.className);
        console.log("[Hero] Hero element parent:", heroElement.parentElement?.tagName);
        console.log("[Hero] Hero element children count:", heroElement.childNodes.length);
      }
    } catch (error) {
      console.error("[Hero] Error checking Hero DOM elements:", error);
    }
    
    return () => {
      console.log("[Hero] Component unmounted");
    };
  }, []);
  
  console.log("[Hero] Render state:", isRendered ? "previously rendered" : "first render");
  
  try {
    console.log("[Hero] Attempting to render JSX");
    return (
      <div className="bg-gradient-to-b from-gray-50 to-white py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              <span className="bg-gradient-to-r from-brand-blue to-brand-purple bg-clip-text text-transparent">Buy & Sell</span> Premium SEO Backlinks
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 mb-10 leading-relaxed">
              Connect with trusted sellers, find high-DA links, and grow your site's authority. A transparent marketplace for SEO professionals.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Button size="lg" className="bg-brand-blue hover:bg-brand-darkBlue text-lg px-8" asChild>
                <Link to="/marketplace">Find Links</Link>
              </Button>
              <Button size="lg" variant="outline" className="text-lg px-8" asChild>
                <Link to="/create-offer">Start Selling</Link>
              </Button>
            </div>
            
            <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
              <div className="p-4 bg-white rounded-lg shadow-sm">
                <div className="text-2xl font-bold text-brand-blue">2,500+</div>
                <div className="text-gray-600">Verified Sellers</div>
              </div>
              <div className="p-4 bg-white rounded-lg shadow-sm">
                <div className="text-2xl font-bold text-brand-blue">10,000+</div>
                <div className="text-gray-600">Link Offers</div>
              </div>
              <div className="p-4 bg-white rounded-lg shadow-sm">
                <div className="text-2xl font-bold text-brand-blue">98%</div>
                <div className="text-gray-600">Satisfaction Rate</div>
              </div>
              <div className="p-4 bg-white rounded-lg shadow-sm">
                <div className="text-2xl font-bold text-brand-blue">24/7</div>
                <div className="text-gray-600">Support</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } catch (error) {
    console.error("[Hero] Error during render:", error);
    // Return fallback UI
    return (
      <div className="p-8 border border-red-200 bg-red-50 rounded-lg m-4">
        <h3 className="font-semibold text-red-600">Error rendering Hero</h3>
        <p className="text-sm text-gray-600">Component failed to render. See console for details.</p>
        <pre className="mt-2 text-xs bg-white p-2 rounded">{error instanceof Error ? error.message : String(error)}</pre>
      </div>
    );
  }
};

export default Hero;
